module.exports = __webpack_public_path__ + "static/media/medal.279eecc2.svg";